import { useState } from 'react';

const DEFAULT_MAX_LENGTH = 200;

interface UseExpandableTextProps {
    text: string;
    maxLength?: number;
}

interface UseExpandableTextReturn {
    text: string;
    isExpandable: boolean;
    isExpanded: boolean;
    toggleExpanded: () => void;
}

type UseExpandableText = (props: UseExpandableTextProps) => UseExpandableTextReturn;

export const useExpandableText: UseExpandableText = ({ text, maxLength = DEFAULT_MAX_LENGTH }) => {
    const isExpandable = text.length > maxLength;
    const [isExpanded, setIsExpanded] = useState(!isExpandable);

    const toggleExpanded = () => setIsExpanded((prev) => !prev);
    const textToDisplay = isExpanded || !isExpandable ? text : `${text.slice(0, maxLength)}...`;

    return {
        text: textToDisplay,
        isExpandable,
        isExpanded,
        toggleExpanded,
    };
};
